import React, { useCallback } from 'react';

import {
  useNotify,
  useUpdate,
  useRefresh,
  useRecordContext,
} from 'react-admin';

import {
  Box,
  Button,
  CircularProgress,
} from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';
import ReplayIcon from '@mui/icons-material/Replay';

const ReprocessRequest = () => {
  const refresh = useRefresh();
  const record = useRecordContext();
  const notify = useNotify();

  const [reprocess, { isLoading, isSuccess }] = useUpdate(
    'requests',
    { id: `${record?.id}/reprocess`, data: { } },
    {
      onSuccess: () => {
        notify('Request Reprocessed');
        refresh();
      },
      onError: () => {
        notify('Could not reprocess request', { type: 'error' });
      },
    },
  );

  const handleSubmit = useCallback(() => {
    reprocess();
  }, [reprocess]);

  return (
    <Box display="flex">
      <Box display="flex">
        {!isLoading && !isSuccess && <Button variant="outlined" startIcon={<ReplayIcon color="primary" />} onClick={handleSubmit}>Reprocess</Button>}
        {isLoading && <Button variant="outlined" disabled startIcon={<CircularProgress size={16} />}>Reprocessing</Button>}
        {isSuccess && <Button variant="outlined" disabled startIcon={<CheckIcon />}>Reprocessed</Button>}
      </Box>
    </Box>
  );
};

ReprocessRequest.defaultProps = {
  addLabel: false,
};
export default ReprocessRequest;
